export default __webpack_public_path__ + "static/media/Cairo-VariableFont_wght.360f4995.ttf";